import { render, staticRenderFns } from "./visitPic.vue?vue&type=template&id=2b6ed0e8&scoped=true"
import script from "./visitPic.vue?vue&type=script&lang=js"
export * from "./visitPic.vue?vue&type=script&lang=js"
import style0 from "./visitPic.vue?vue&type=style&index=0&id=2b6ed0e8&prod&lang=scss&scoped=true"
import style1 from "./visitPic.vue?vue&type=style&index=1&id=2b6ed0e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ed0e8",
  null
  
)

export default component.exports